import { z } from 'zod'
import { ShoppingPromotionSchema } from '@reward-platform/shared-schemas'
import { PriceLadderSchema, PricedPaymentOptionSchema } from '../../common'

export const ExperienceAvailabilityDataTransferObjectSchema = z.object({
  recommendationId: z.string(),
  ticketOptions: z
    .array(
      z.object({
        experienceDetailsTicketName: z.string().optional(), // * Note: title should be required, waiting for JRT
        experienceDescription: z.string(),
        timesAndPrices: z.array(
          z.object({
            cashPrice: z.number(),
            aviosPrice: z.number(),
            collectAmount: z.number(),
            pricingLadder: z.array(PriceLadderSchema).optional(),
            paymentOptions: z.array(PricedPaymentOptionSchema).optional(),
            priceApplicabilityId: z.string(),
            tourStartTimes: z.array(z.string()).optional(),
            promotions: z.array(ShoppingPromotionSchema).optional(),
            baseLoyalty: z.number().optional(),
          })
        ),
      })
    )
    .optional(),
})

export type ExperienceAvailabilityDataTransferObject = z.infer<
  typeof ExperienceAvailabilityDataTransferObjectSchema
>
